//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getPointsAccounts, getPointsLedger } from '@/api/distributionAlliance';
var SOURCE = {
  REGISTER: '注册赠送',
  INVITE: '邀请奖励',
  SIGN_IN: '签到',
  TASK: '任务',
  CONSUME_REBATE: '消费返积分',
  VERIFY_FREEZE: '核销冻结',
  VERIFY_DEDUCT: '核销抵扣',
  LEADER_POINTS_TRANSFER: '积分核销转入团长',
  MANUAL: '人工调整',
  REVERSAL: '冲正'
};
var DIRECTION = {
  1: '收入',
  2: '支出',
  3: '冻结',
  4: '解冻',
  5: '过期'
};
export default {
  name: 'AlliancePoints',
  data: function data() {
    return {
      SOURCE: SOURCE,
      tab: 'account',
      dateRange: [],
      accountLoading: false,
      accountList: [],
      accountUsers: {},
      accountTotal: 0,
      accountQuery: {
        contact: '',
        page: 1,
        size: 20
      },
      ledgerLoading: false,
      ledgerList: [],
      ledgerUsers: {},
      ledgerTotal: 0,
      ledgerQuery: {
        uid: null,
        direction: null,
        sourceType: '',
        keyword: '',
        page: 1,
        size: 20
      }
    };
  },
  created: function created() {
    this.loadAccounts(1);
  },
  methods: {
    onTabChange: function onTabChange() {
      if (this.tab === 'ledger' && !this.ledgerList.length) {
        this.loadLedger(1);
      }
    },
    clean: function clean(query) {
      var params = {};
      Object.keys(query).forEach(function (key) {
        var value = query[key];
        if (value !== '' && value !== null && value !== undefined && !Number.isNaN(value)) {
          params[key] = value;
        }
      });
      return params;
    },
    userName: function userName(users, uid) {
      var u = users[uid];
      return u ? u.nickname || '(未设置昵称)' : '查无此人';
    },
    userPhone: function userPhone(users, uid) {
      var u = users[uid];
      return u && u.phone ? ' · ' + u.phone : '';
    },
    sourceText: function sourceText(s) {
      return SOURCE[s] || s || '-';
    },
    directionText: function directionText(d) {
      return DIRECTION[d] || '-';
    },
    directionTagType: function directionTagType(d) {
      return {
        1: 'success',
        2: 'danger',
        3: 'warning',
        4: 'info',
        5: 'info'
      }[d] || 'info';
    },
    loadAccounts: function loadAccounts(page) {
      var _this = this;
      if (page) this.accountQuery.page = page;
      this.accountLoading = true;
      getPointsAccounts(this.clean(this.accountQuery)).then(function (res) {
        _this.accountList = res && res.list || [];
        _this.accountUsers = res && res.users || {};
        _this.accountTotal = res && res.total || 0;
      }).finally(function () {
        _this.accountLoading = false;
      });
    },
    onAccountSize: function onAccountSize(size) {
      this.accountQuery.size = size;
      this.loadAccounts(1);
    },
    resetAccounts: function resetAccounts() {
      this.accountQuery = {
        contact: '',
        page: 1,
        size: 20
      };
      this.loadAccounts(1);
    },
    loadLedger: function loadLedger(page) {
      var _this2 = this;
      if (page) this.ledgerQuery.page = page;
      var params = this.clean(this.ledgerQuery);
      if (this.dateRange && this.dateRange.length === 2) {
        params.startTime = this.dateRange[0];
        params.endTime = this.dateRange[1];
      }
      this.ledgerLoading = true;
      getPointsLedger(params).then(function (res) {
        _this2.ledgerList = res && res.list || [];
        _this2.ledgerUsers = res && res.users || {};
        _this2.ledgerTotal = res && res.total || 0;
      }).finally(function () {
        _this2.ledgerLoading = false;
      });
    },
    onLedgerSize: function onLedgerSize(size) {
      this.ledgerQuery.size = size;
      this.loadLedger(1);
    },
    resetLedger: function resetLedger() {
      this.dateRange = [];
      this.ledgerQuery = {
        uid: null,
        direction: null,
        sourceType: '',
        keyword: '',
        page: 1,
        size: 20
      };
      this.loadLedger(1);
    },
    viewLedger: function viewLedger(uid) {
      this.tab = 'ledger';
      this.ledgerQuery.uid = uid;
      this.loadLedger(1);
    }
  }
};